import { Link } from "react-router-dom";
import Button from '@mui/material/Button';
import HomeIcon from '@mui/icons-material/Home';

import ContentLayout from "~/components/ContentLayout";
import { ROUTES } from "~/const";
import { trans } from "~/utils/trans";

import "./style.less";

// text misto obrazku (puvodni obrazek mel cesky napis, v anglictine nesel prelozit)
export default function Page404() {
	const mainContent = <div className="page404" slot="mainContent">
		<div className="page404__code" aria-hidden="true">4<span>0</span>4</div>
		<h1 className="page404__title">{trans("page404.title")}</h1>
		<p className="page404__text">{trans("page404.text")}</p>
		{/* koren presmeruje prihlaseneho na jidelnicek, neprihlaseneho na prihlaseni */}
		<Button className="MyButton" component={Link} to={ROUTES.root} variant="contained" startIcon={<HomeIcon />}>{trans("page404.home")}</Button>
	</div>;

	return <ContentLayout mainContent={mainContent} />;
}
